import { twMerge } from "tailwind-merge";

export default function tw(
  ...classes: (string | false | null | undefined)[]
): string {
  return twMerge(...classes);
}
